import React from 'react';

const MapPopupStyles: React.FC = () => {
    return (
        <style>
            {`
                .fancy-popup .mapboxgl-popup-content {
                    border-radius: 12px;
                    padding: 0;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                    border: 1px solid rgba(0,0,0,0.05);
                }
                .fancy-popup .mapboxgl-popup-close-button {
                    padding: 5px 8px;
                    color: #95a5a6;
                    font-size: 16px;
                }
                .fancy-popup .mapboxgl-popup-close-button:hover {
                    background-color: transparent;
                    color: #2c3e50;
                }
            `}
        </style>
    );
};

export default MapPopupStyles;
